// ————————————————————————————————————————————— LIB. ————————————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //

import { OverlayScrollbars } from "overlayscrollbars";

// ———————————————————————————————————————————— UTIL. ————————————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //

// ...

// ———————————————————————————————————————— EVENT HANDLERS ———————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //

// ...

// ———————————————————————————————————————————— ASSETS ———————————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //

const logArgs = { eventName: "init_projectsNav", inline: true, disabled: false };
const msgs = {
  start: ["init. projectsNav"],
  end: ["init. projectsNav", "init. success"],
  no_el: ["init. projectsNav", "no valid DOM el. provided"],
};

// —————————————————————————————————————— INIT. METHOD DEF. ——————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //

export default function init_projectsNav() {
  //////////////////////////////////////////// Setup /////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////////////////////////////

  const { projectsNav, projectLinks } = this.ref;
  this.logger("init", msgs.start, "action", logArgs);

  //////////////////////////////////////////// ACTION ////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////////////////////////////

  // Custom project nav. scroll bar init. //
  const wrpr_scroll = projectsNav.querySelector('[data-ref="wrpr_scroll"]');
  if (wrpr_scroll) {
    const inst_os = OverlayScrollbars(wrpr_scroll, { scrollbars: { theme: "os-theme-cef" } });
  }

  // Project links init. //
  if (projectLinks)
    projectLinks.forEach((link) => {
      link.addEventListener("click", () => {
        this.setState({ activeGridItem: link.dataset.id });
      });
    });

  /////////////////////////////////////////// Conclude ///////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////////////////////////////

  this.logger("init", msgs.end, "success", logArgs);
}

// ———————————————————————————————————————————————————————————————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //
